// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","myBookmarksContainer":"myBookmarksContainer-12epc","myBookmarksTitle":"myBookmarksTitle-pVMh9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/myRoutes/_myBookmarksPage.css
// module id = 1259
// module chunks = 1